import SystemReloadModule from './system-reload.module'

export default SystemReloadModule
